import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
  HostListener,
  ChangeDetectorRef, // LUMBA-1308
  Output,
  EventEmitter,
  OnDestroy,
  ElementRef,
  Renderer2,
  ViewChild,
  ViewChildren,
  QueryList
} from '@angular/core'

import { AppState } from '../app.service'
import { Option } from '../option/option.model'
import { Path } from '../path/path-v2.model'
import { Poll, PollStats } from '../poll/poll.model'
import { PollService } from '../poll/poll.service'
import { CordovaService } from '../cordova.service'
import { SpinnerService } from '../spinner.service'
import mixpanel from 'mixpanel-browser'
import { expandOnEnterAnimation, slideInDownAnimation } from 'angular-animations'
import { PopoverController } from '@ionic/angular'
import { PopoverComponent } from '../shared/popover/popover.component'
import { I18n } from '../i18n.service'
import { DomSanitizer } from '@angular/platform-browser';
import { HomeUiService } from '../new-design/home-ui.service';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations'

@Component({
  selector: 'first90-poll-v2',
  templateUrl: './poll-v2.component.html',
  styleUrls: ['./poll-v2.component.scss'],

  animations: [
    expandOnEnterAnimation({ duration: 400 }),
    slideInDownAnimation({duration:300}),

    trigger('animateContent', [
      transition(':enter', [
        query(':scope > *', [
          style({ opacity: 0, transform: 'translateY(8px)' })
        ], { optional: true }),

        query(':scope > *', [
          stagger(100, [
            animate(
              '800ms cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            )
          ])
        ], { optional: true })
      ]),

      transition(':leave', [
        animate(
          '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
          style({ opacity: 0, transform: 'translateY(-75px)' })
        )
      ])
    ])
  ]
})
export class PollV2Component implements OnInit, AfterViewInit, OnChanges{
  @Input() poll
  @Input() isPreview: boolean
  @Input() inverted = false
  @Output() blurCard= new EventEmitter<any>();
  @Input() progressItems = [];
  @Input() currentIndex = 0;
  @Input() screenId: any;
  @Input() chapterIndex: number;
  @Input() stepIndex: number
  @Input() animationClass: boolean = false;
  @ViewChildren('questionRef') questionRefs: QueryList<ElementRef>;
  // Isdispaly:boolean=true;

  enabled = true // TODO: Get it from the path
  nameTQ: string // TODO: Get it from the path
  nameHYPA: string // TODO: Get it from the path
  path: Path
  stats: PollStats
  status: string
  chart = []
  loading: boolean = false;
  isMobileWebIos = false;
  isMobileWeb=false;
  statsPer: number[]
  isMobile: boolean
  innerQuestionHtml: any;
  selectedOption
  answeredOptionData;
 @Input() enable= false;
 showActionpoints=false;
 showFinalize=false;
  enableFinal = false;
  constructor(
    private pollService: PollService,
    private appState: AppState,
    private spinnerService: SpinnerService,
    private popover:PopoverController,
    private cordovaService: CordovaService,
    private cdRef: ChangeDetectorRef, // LUMBA-1308
    private i18n: I18n,
    public homeUIService: HomeUiService,
    private render: Renderer2,
    private _sanitizer: DomSanitizer,
  ) {
    this.path = this.appState.get('currentPath')
    this.isMobile = this.appState.get('isMobile')
    // this.isEnabled()
  }

  ngOnInit() {
    this.innerQuestionHtml = this._sanitizer.bypassSecurityTrustHtml(this.poll?.screen?.content?.question ?? '');
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    console.log("this.isMobileWeb value", this.isMobileWeb, this.poll);
    this.loading = false;
    if (this.poll && this.poll?.screen?.isCompleted) {
      this.answeredOptionData = this.poll?.screen?.userResponse
      this.stats = this.poll?.screen?.userResponse?.stats
      this.poll.screen.content.options =
        this.poll.screen.content.options.map(opt => ({
          ...opt,
          isSelected: opt.optionId === this.answeredOptionData?.optionId
        }));
    } else if (this.poll && !this.poll?.screen?.isCompleted) {
      // Restore from client-side AppState cache (API refetch wipes unsaved selections)
      const cached = this.appState.get('pollSelections')?.[this.poll?.screenContentId];
      if (cached != null) {
        this.poll.screen.content.options = this.poll.screen.content.options.map((opt: any) => ({
          ...opt,
          isSelected: opt.optionId === cached
        }));
        this.selectedOption = this.poll.screen.content.options.find((opt: any) => opt.optionId === cached);
        this.enableFinal = true;
      } else {
        const alreadySelected = this.poll?.screen?.content?.options?.find((opt: any) => opt.isSelected);
        if (alreadySelected) {
          this.selectedOption = alreadySelected;
          this.enableFinal = true;
        }
      }
    }
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }
  ngAfterViewInit() {
    this.questionRefs.changes.subscribe(() => {
      setTimeout(() => this.changeSubTextFont());
    });
    this.changeSubTextFont();
    if (this.poll?.screen?.isCompleted) this.setStats()
  }
enableBlur(val) {
  this.enable=val;
 // if(this.enable)
    this.blurCard?.emit({
      enable: this.enable,
      poll: this.poll
    })
    
}
  ngOnChanges(changes: SimpleChanges) {
    if (changes['poll']) {
      this.innerQuestionHtml = this._sanitizer.bypassSecurityTrustHtml(
        this.poll?.screen?.content?.question ?? ''
      );
      setTimeout(() => {
        this.changeSubTextFont();
        this.cdRef.detectChanges();
      }, 100);
    }
    if (!changes['poll'] || changes['poll'].firstChange) { return false }
    if (this.poll && this.poll?.screen?.isCompleted) {
      this.stats = this.poll?.screen?.userResponse?.stats
      this.answeredOptionData = this.poll?.screen?.userResponse;
      window.requestAnimationFrame(() => {
        this.setStats()
      })
    }
  }


  onOptionClicked(option) {
    mixpanel.track('Step' + JSON.stringify(this.poll.step), { 'question': this.poll?.screen?.content?.title, 'selectedOption': option.text })
    if (this.poll?.screen?.isCompleted) { return false }
    if (this.isPreview) { return false }
    this.poll?.screen?.content?.options?.forEach((opt) => {
      if (opt.optionId == option.optionId) {
        option.isSelected = true;
        // opt.isSelected = true;
      } else {
        opt.isSelected = false;
      }
    });
    this.enable = true;
    this.enableFinal = true;
    this.showFinalize=true;
    setTimeout(()=>{
      this.showFinalize=false;
    },600);
    this.selectedOption = option;
    // Persist selection so it survives getStepDetails refetch on step close/reopen
    const selections = this.appState.get('pollSelections') ?? {};
    selections[this.poll?.screenContentId] = option.optionId;
    this.appState.set('pollSelections', selections);
          console.log("this.this.selectedOption in in-step", this.selectedOption, this.poll);

  }
   onAnimationDone(event: any) {
    const element = event.element as HTMLElement;
    console.log("El",element)
    let primaryColor;
      
    primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--highlight-color');
    element.style.borderColor = primaryColor ;
  }
  finalizeMcq() {
    this.loading = true;
    const pollSelections = this.appState.get('pollSelections') ?? {};
    delete pollSelections[this.poll?.screenContentId];
    this.appState.set('pollSelections', pollSelections);
    this.cdRef.detectChanges()
        let input = {
      step_id:this.poll?.stepId,
      screen_id:this.poll?.screenId,
      screen_content_id: this.poll?.screenContentId,
      option_id: this.selectedOption?.optionId,
     }
      this.pollService.savePollAnswersforKyper(input).subscribe(response => {
        this.stats = response.data.answer.stats
        this.answeredOptionData = response.data.answer;
         this.poll.screen.userResponse =  this.answeredOptionData
        this.poll.screen.userResponse.stats = this.stats
        // Mark completed only now that the server stored the answer (drives the mandatory gate).
        this.poll.screen.isCompleted = true;
        let path = this.appState.get('currentPath')
        let stepScreens = path.kyperChapters?.[this.chapterIndex]?.steps?.[this.stepIndex]?.screens?.[this.currentIndex]?.screenContents
        if (stepScreens) {
          stepScreens.isCompleted = true;
          if(!stepScreens.userResponse){
            stepScreens.userResponse={}
          }
          stepScreens.userResponse = this.answeredOptionData
          stepScreens.userResponse.stats = this.stats
        }
        let dailyStepsData = this.appState.get('DailyStepsData');
        let dailyStepScreens = dailyStepsData?.[this.chapterIndex]?.steps?.[this.stepIndex]?.screens?.[this.currentIndex]?.screenContents;
         if (dailyStepScreens) {
          dailyStepScreens.isCompleted = true;
          if(!dailyStepScreens.userResponse){
            dailyStepScreens.userResponse={}
          }
          dailyStepScreens.userResponse = this.answeredOptionData
          dailyStepScreens.userResponse.stats = this.stats
        }
        this.appState.set('DailyStepsData', dailyStepsData);
        this.appState.set('currentPath', path)
      this.setStats()
      this.loading = false
      this.showActionpoints=true;
      setTimeout(()=>{
        this.showActionpoints=false;
      },3000);
      setTimeout(()=>{
      this.enableBlur(this.enable);
      },500);
      this.cdRef.detectChanges()
    }, error => {
         this.poll.screen.isCompleted = false;
      this.selectedOption.isSelected = false;
      this.loading = false
      this.cdRef.detectChanges() // LUMBA-1308
    })  
  }

  changeSubTextFont() {
    this.questionRefs?.forEach(ref => {
      if (ref?.nativeElement) {
        this.applyStylesToAllInnerTags(ref.nativeElement);
      }
    });
  }

 applyStylesToAllInnerTags(element: HTMLElement) {
  if (!element) { return; }
  const childElements = Array.from(element.children);
  childElements.forEach((childElement: Element) => {
    const tagName = childElement.tagName.toLowerCase();

    if (tagName === 'ol' || tagName === 'ul') {
      this.render.setStyle(childElement, 'list-style', 'none');
      this.render.setStyle(childElement, 'padding-left', '1.5em');
    }

    if (tagName === 'li') {
      const dataList = childElement.getAttribute('data-list');

      // Hide Quill's fake bullet span
      const qlUi = childElement.querySelector('.ql-ui');
      if (qlUi) {
        this.render.setStyle(qlUi, 'display', 'none');
      }

      if (dataList === 'bullet') {
        this.render.setStyle(childElement, 'list-style-type', 'disc');
        this.render.setStyle(childElement, 'display', 'list-item');
        this.render.setStyle(childElement, 'margin-left', '1em');
      } else if (dataList === 'ordered') {
        this.render.setStyle(childElement, 'list-style-type', 'decimal');
        this.render.setStyle(childElement, 'display', 'list-item');
        this.render.setStyle(childElement, 'margin-left', '1em');
      }
    }

    this.applyStylesToAllInnerTags(childElement as HTMLElement);
  });
}

  setStats() {
    if (!this.stats) {
      return
    }
    if (!this.stats?.data) {
      return
    }
    if (!this.stats.data.length) {
      return
    }

    const total = this.stats.data.reduce((sum, n) => sum + n)
    if (!total) {
      return
    }

    this.statsPer = this.stats.data.map(n => Math.round(n * 100 / total))
  }

  private isEnabled() {
    this.enabled = this.path.enabledAttributes['polls']
  }

  async presentPopover(ev) {
    const dynamicText = this.i18n.t('These charts show the breakdown of answers among all your colleagues in this cycle.');
    const popover = await this.popover.create({
      component: PopoverComponent,
      translucent: true,
      event: ev,
      mode:'ios',
      showBackdrop: true,
      cssClass: 'custom-popover',
      componentProps: {
        dynamicText: dynamicText,
      },
    });
    await popover.present();
    await popover.onDidDismiss();
  }

  @HostListener('click', ['$event'])
  onLinkClick(e) {
    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        console.log('cordova click')
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        window.open(e.target.href, '_blank')
      }
    }
  }
  // ngOnDestroy(): void {
  //   this.showFinalize=false;
  // }
}
